module.exports = __webpack_public_path__ + "img/chpc_footer_gzh.2ec2959a.png";